import { configureStore } from "@reduxjs/toolkit";
import { Middleware } from "redux";
import authReducer, { AuthStatus } from "./reducers/auth";
import userReducer, { clearUserInfo, getSelfData } from "./reducers/user";
import personReducer from "./reducers/person";
import teamReducer from "./reducers/team";
import taxonomyReducer from "./reducers/taxonomy";
import adminUsersReducer from "./reducers/adminUsers";
import requestsReducer from "./reducers/requests";
import chatReducer from "./reducers/chat";

const logger: Middleware = (store: any) => (next: any) => (action: any) => {
  if (process.env.NODE_ENV !== "production") {
    console.group(action.type);
    console.info("Dispatching action:", action);
    const result = next(action);
    console.log("Next state:", store.getState());
    console.groupEnd();
    return result;
  } else {
    const result = next(action);
    return result;
  }
};

const userDataSetupChain: Middleware =
  (store: any) => (next: any) => (action: any) => {
    let result;
    let current_state;
    switch (action.type) {
      case "auth/checkAuthRequestStatus/fulfilled":
      case "auth/loginRequestStatus/fulfilled":
      case "auth/setAuthToken":
        result = next(action);
        current_state = store.getState();

        if (current_state.auth.status === AuthStatus.Authenticated) {
          store.dispatch(getSelfData(current_state.auth.auth_token));
        }

        return result;
      default:
        result = next(action);
        return result;
    }
  };

const clearUserInfoOnLogout: Middleware =
  (store: any) => (next: any) => (action: any) => {
    if (action.type == "auth/logoutRequestStatus/fulfilled") {
      const result = next(action);

      store.dispatch(clearUserInfo());

      return result;
    } else {
      const result = next(action);
      return result;
    }
  };

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    person: personReducer,
    team: teamReducer,
    taxonomy: taxonomyReducer,
    adminUsers: adminUsersReducer,
    requests: requestsReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      // .prepend(spreadClasses)
      .concat(logger)
      .concat(userDataSetupChain)
      // .concat(fetchTermsAfterCreationAndUpdate)
      .concat(clearUserInfoOnLogout),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
